// import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
 
// export default class EditAction extends Component {
//     const handleOverspeedClick = (e) => {
//         e.stopPropagation();
//         props.context.componentParent.onClickEditBlock(props);
//     };

//         return (
//             <div>
//             <button onClick={handleOverspeedClick} style={{padding: "0px", width: "46px", height: "21px"}} className={"custom-btn f12 label label-success "} title="Edit" ><i className="icofont icofont-edit"></i> Edit</button>
         
//         </div>
//         );
// }


import React from 'react';

const EditItem = (props) => {
//   console.log("testing",props)
  const handleEditClick = () => {
    // const { context} = props;
    // console.log("data",data)
    props.context.onClickEditBlock(props);
    // console.log("10",10)
  };

  return (
    <div>
            <button onClick={handleEditClick} style={{padding: "0px", width: "46px", height: "21px"}} className={"custom-btn f12 label label-success "} title="Edit" ><i className="icofont icofont-edit"></i> Edit</button>
         
        </div>
  );
};

export default EditItem;

